import { FixedMarkerOverrides, FloatingMarker } from 'baseui/map-marker';
import { userState } from '../../../../storage/userStates';
import { Marker } from 'react-map-gl/mapbox';
import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { useStyles } from '../../../../hooks/useStyles';
import { isValidPosition } from '../../../../utils/map';

type Props = {
  userId: string;
};
function UserMarker({ userId }: Readonly<Props>) {
  const { theme } = useStyles();
  const user = useRecoilValue(userState(userId));

  if (!user?.lastPosition) return null;

  const floatingMarkerOverrides: FixedMarkerOverrides = {
    Root: {
      style: () => ({
        transform: `translateY(-50%)`,
      }),
    },
    OuterAnchor: {
      style: { backgroundColor: theme.colors.negative },
    },
  };

  const point = {
    lat: user.lastPosition.latitude,
    lng: user.lastPosition.longitude,
  };

  const isValidPoint = isValidPosition(point.lat, point.lng);

  if (!isValidPoint) return null;

  return (
    <Marker
      latitude={point.lat}
      longitude={point.lng}
    >
      <FloatingMarker
        label={`${user.firstName} ${user.lastName}`}
        overrides={floatingMarkerOverrides}
        size="small"
        anchorType="circle"
      />
    </Marker>
  );
}

export default memo(UserMarker);
